import React from "react";
import { LazyLoadComponent } from "react-lazy-load-image-component";
import { normalizeString } from "../../../util/util";
import * as S from "./styles";

export default function CourseCard({
  image = "",
  title = "",
  slug = "",
  bigCard,
  showItemTitle = "",
  link = "",
}) {
  const isAuthor = link === "/professores";

  return (
    <S.CardLink
      className={`${bigCard ? "big-card" : "small-card"}`}
      to={`../${slug}`}
      title={title}
      id={`btn-carousel-${normalizeString(title)}`}
      name={`btn-carousel-${normalizeString(title)}`}
    >
      {!showItemTitle ? (
        <LazyLoadComponent threshold="50" delayTime="0">
          <S.ThumbImage
            src={image}
            alt={title}
            className={`${isAuthor && "fit-cover"}`}
          />
        </LazyLoadComponent>
      ) : (
        <S.ThumbContainer>
          <LazyLoadComponent threshold="50" delayTime="0">
            <S.ThumbImage
              src={image}
              alt={title}
              className={`${isAuthor && "fit-cover"}`}
            />
          </LazyLoadComponent>
          <S.ThumbCaption>
            <p>{title}</p>
          </S.ThumbCaption>
        </S.ThumbContainer>
      )}
    </S.CardLink>
  );
}
